import React from 'react';
import LoadingCircle from './LoadingCircle';

export default (props) => {
  const w = props.width || '22px';
  const h = props.height || w;
  return <LoadingCircle {...props} width={w} height={h} />;
};
